// Keep native product/Page paths in the pilot theme, including dynamically
// inserted finder, comparison and quick-buy links. Server-rendered links already
// carry this context so ordinary navigation also works without JavaScript.
const root=document.querySelector('.pa');
const navigation=window.PANART_DATA?.detailNavigation||{};
const preview=navigation.themeId||window.PANART_PREVIEW_THEME||new URL(location.href).searchParams.get('preview_theme_id');
const localPreview=root?.dataset.paPreview==='true';
const pilotHandles=new Set((window.PANART_DATA?.series||[])
 .filter(series=>(navigation.pilotSeriesIds||[]).includes(String(series.id)))
 .flatMap(series=>(series.products||[]).map(product=>product.handle)));
const rewrite=()=>root?.querySelectorAll('a[href]').forEach(a=>{
 const raw=a.getAttribute('href');
 if(!raw||raw.startsWith('#'))return;
 let url;try{url=new URL(raw,location.origin);}catch{return;}
 if(![location.origin,'https://fleury.art','https://fleurypunktart.myshopify.com'].includes(url.origin))return;
 const product=url.pathname.startsWith('/products/panart-');
 const panartPage=url.pathname.startsWith('/pages/panart-');
 if(product&&pilotHandles.has(url.pathname.split('/').at(-1))&&navigation.productView)url.searchParams.set('view',navigation.productView);
 if(preview&&(product||panartPage))url.searchParams.set('preview_theme_id',preview);
 const external=localPreview&&(/^\/(products|policies)\//.test(url.pathname)||url.pathname==='/cart'||url.pathname==='/');
 if(external)a.href='https://fleury.art'+url.pathname+url.search+url.hash;
 else if(product||panartPage)a.setAttribute('href',url.pathname+url.search+url.hash);
});
rewrite();
if(root)new MutationObserver(rewrite).observe(root,{childList:true,subtree:true});

// Animate on entry without hiding content while scripts load or if they fail.
// No scroll listener or layout shifts; reduced-motion users see the static layout.
const motionRoot=document.querySelector('.pa');
const motionPreference=window.matchMedia('(prefers-reduced-motion: reduce)');
if(motionRoot&&'IntersectionObserver' in window&&Element.prototype.animate){
 const seen=new WeakSet(),active=new Set();
 const selector='.pa-atlas-grid > article,.pa-finder-result,.pa-video-card,.pa-section-head,.pa-anatomy';
 const observer=new IntersectionObserver(entries=>{
  for(const entry of entries){
   if(!entry.isIntersecting)continue;
   observer.unobserve(entry.target);
   if(motionPreference.matches||entry.target.contains(document.activeElement))continue;
   const animation=entry.target.animate([{opacity:.45,transform:'translateY(16px)'},{opacity:1,transform:'translateY(0)'}],{duration:420,easing:'cubic-bezier(.2,.7,.2,1)'});
   active.add(animation);animation.finished.catch(()=>{}).finally(()=>active.delete(animation));
  }
 },{threshold:.08,rootMargin:'0px 0px -24px 0px'});
 const watch=node=>{if(!(node instanceof Element))return;const items=node.matches(selector)?[node]:[...node.querySelectorAll(selector)];for(const el of items)if(!seen.has(el)){seen.add(el);observer.observe(el);}};
 watch(motionRoot);
 new MutationObserver(records=>{for(const record of records){record.addedNodes.forEach(watch);for(const node of record.removedNodes){if(!(node instanceof Element))continue;observer.unobserve(node);node.querySelectorAll(selector).forEach(el=>observer.unobserve(el));}}}).observe(motionRoot,{childList:true,subtree:true});
 motionPreference.addEventListener('change',()=>{if(motionPreference.matches)for(const animation of active)animation.cancel();});
}
